import { defineComponent as _defineComponent } from 'vue'
import { AxiosError } from "axios";
import { ref } from "vue";

import { apiClient } from "@/plugins/api-client";
import { useNotificationStore } from "@/stores/notification";


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordRecoveryView',
  setup(__props) {

const isFormValid = ref<boolean>(false);

const email = ref<string>("");
const notificationStore = useNotificationStore();
const emptyRule = (message: string) => (v: string) => !!v || message;

const doPasswordReset = async () => {
  try {
    await apiClient.userManagement.forgotPassword({ email: email.value });
    notificationStore.addNotification({
      message:
        "If you entered a valid email address, an email with a link to reset your password was sent.",
      type: "success",
    });
  } catch (e: unknown) {
    const error = e as AxiosError;
    notificationStore.addNotification({
      message: error.message,
      type: "error",
    });
  }
};

return { __sfc: true,isFormValid, email, notificationStore, emptyRule, doPasswordReset }
}

})